<div class="page-transition" [class.active]="isTransitioning && currentPhase">
    <div class="transition-overlay" [style.background]="getCurrentPhaseColor()" *ngIf="isTransitioning && currentPhase">
        <div class="transition-content">
            <div class="phase-info">
                <img [src]="currentPhase.icon" [alt]="currentPhase.name" class="phase-icon">
            </div>
        </div>
    </div>
</div>